import React, { useState } from "react";
import bloodpressure from "../../../Assets/Images/bloodpressure.png";
import heartrate from "../../../Assets/Images/heart.png";
import pulse from "../../../Assets/Images/pulserate.png";
import weight from "../../../Assets/Images/Svg/weight.svg";
import respiration from "../../../Assets/Images/Svg/oxygen.svg";
import bmi from "../../../Assets/Images/bmi.png";
import temperature from "../../../Assets/Images/temp.png";
import vitals1 from "../../../Assets/Images/linechart.jpg";

function HealthTrends() {

  const images = [
    {
      id: 1,
      src: bloodpressure,
      alt: "Image 1",
      title: "Blood Pressure",
      content: vitals1,
    },
    {
      id: 2,
      src: heartrate,
      alt: "Image 2",
      title: "Heart Rate",
      content: "This is the content for Image 2.",
    },
    {
      id: 3,
      src: pulse,
      alt: "Image 3",
      title: "Pulse Oxygen",
      content: "This is the content for Image 3.",
    },
    {
      id: 4,
      src: weight,
      alt: "Image 3",
      title: "Weight",
      content: "This is the content for Image 3.",
    },
    {
      id: 5,
      src: respiration,
      alt: "Image 4",
      title: "Respiration Rate",
      content: "This is the content for Image 4.",
    },
    {
      id: 6,
      src: bmi,
      alt: "Image 5",
      title: "BMI",
      content: "This is the content for Image 5.",
    },
    {
      id: 7,
      src: temperature,
      alt: "Image 6",
      title: "Temperature",
      content: "This is the content for Image 6.",
    },
  ];

  const [selectedImage, setSelectedImage] = useState(images[0]);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };



  return (
    <div className="card h-[370px] w-[370px] m-5 border rounded-lg">
      <div className="header h-[13%] bg-[#B8DAFF] flex items-center justify-center rounded p-2">
        <h1 className="font-bold text-normal text-[#0d203f] mt-3">HealthTrends</h1>
      </div>
      <div className="body h-[75%] overflow-y-auto bg-white scrollwidth border-t-2 border-t-[#4880DE]">
        <div className="flex justify-between items-center p-2 m-3 border rounded-md">
        <div className="p-2">
              <div className="flex space-x-4">
                {images.map((image) => (
                  <img
                    key={image.id}
                    src={image.src}
                    alt={image.alt}
                    className={`w-6 h-6 object-cover cursor-pointer ${
                      selectedImage.id === image.id
                        ? "border-blue-500"
                        : "border-gray-300"
                    }`}
                    onClick={() => handleImageClick(image)}
                  />
                ))}
              </div>
                <div>
                <h2 className="text-sm mt-3 font-bold mb-2">
                  {selectedImage.title}
                </h2>
                    <img src={vitals1} alt="" className="w-full h-40"/>
                </div>
         
            </div>

        </div>
      </div>
      <div className="footer h-[44px] bg-[#B8DAFF] rounded"></div>
    </div>
  );
}

export default HealthTrends;
